<template>
  <tab-container>
    <div slot="operation">
      <a-range-picker
        style="width: 380px"
        :show-time="{
          defaultValue: [
            $moment('00:00:00', 'HH:mm:ss'),
            $moment('23:59:59', 'HH:mm:ss'),
          ],
        }"
        format="YYYY-MM-DD"
        @ok="onChangeTimeRange"
        @change="initData"
      />
    </div>
    <a-table
      :columns="columns"
      :data-source="tableData"
      :pagination="pagination"
      :row-key="record => record.pkId"
      :loading="loading"
      @change="handlePagination"
    />
  </tab-container>
</template>

<script>
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import TabContainer from '@/views/green-construction/components/tab-container.vue';
import { deviceTypeEnum } from '@/enum/device';
import AlarmTable from '@/views/green-construction/components/mixins/alarm-table';

@Component({
  components: {
    TabContainer,
  },
})
export default class AlarmMessage extends mixins(AlarmTable) {
  get columns() {
    return [
      {
        dataIndex: 'index',
        customRender: (text, row, index) => (
          <span>{(this.pagination.current - 1) * 10 + index + 1}</span>
        ),
        title: this.$t('safety.index'),
        align: 'center',
        ellipsis: true,
        width: 80,
      },
      {
        align: 'left',
        title: this.$t('greenConstruction.alarmTime'),
        dataIndex: 'alarmTime',
        ellipsis: true,
        customRender: txt =>
          txt ? this.dayjs(txt).format('YYYY-MM-DD HH:mm:ss') : '',
      },
      {
        align: 'left',
        title: this.$t('greenConstruction.alarmType'),
        dataIndex: 'subType',
        customRender: text => (text ? this.exchangeValue(text) : ''),
        ellipsis: true,
      },
      {
        align: 'left',
        title: this.$t('greenConstruction.threshold') + '(µg/m³)',
        dataIndex: 'threshold',
        ellipsis: true,
      },
      {
        align: 'left',
        title: this.$t('greenConstruction.liveData') + '(µg/m³)',
        dataIndex: 'alarmValue',
        ellipsis: true,
      },
    ];
  }
  deviceGroup = deviceTypeEnum.DUST.deviceGroup;
}
</script>

<style lang="less" module></style>
